// extracted by mini-css-extract-plugin
module.exports = {"castCrewComponentWrapper":"dV","castCrewHeader":"dW","castCrewBody":"dX","castCrewTitle":"dY","slipnslideArrow":"dZ"};